package org.solyton.solawi.bid.module.banking.data

import org.solyton.solawi.bid.module.banking.data.application.actions
import org.solyton.solawi.bid.module.banking.data.application.modals

val bankingApplicationActions by lazy {
    actions
}

val bankingApplicationModals by lazy {
    modals
}
